import { trpc } from '@/shared/api';

/** 한 상품이 허용한 잉크 색상 목록 조회 — 상품 편집 화면의 허용 잉크 섹션이 쓴다. */
export const useProductInkColorsQuery = (productId: string) =>
  trpc.productManagement.inkColors.listForProduct.useQuery({ productId });
